export default {
  init() {
    $('.blog-list').slick({
      dots: false,
      slidesToShow: 1,
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-team.js